import { createModule, type Module } from 'yet-another-react-lightbox';

interface SlideInfoPluginProps {
  isInline?: boolean;
}

const gallerySlideInfoModule = (isInline: boolean = false) =>
  createModule('GallerySlideInfo', ({ children }) => {
    const portalId = isInline ? 'portal-root-inline' : 'portal-root-fullscreen';

    return (
      <>
        <div id={portalId} data-testid="portal-root"></div>
        {children}
      </>
    );
  });

const SlideInfoPlugin =
  ({ isInline = false }: SlideInfoPluginProps) =>
  ({ addSibling }: { addSibling: (target: string, module: Module, precede?: boolean) => void }) =>
    addSibling('navigation', gallerySlideInfoModule(isInline));

export default SlideInfoPlugin;
